export const getMapFromObject = <T, R>(object: Record<any, any>) => {
  return new Map<T, R>(Object.entries(object).map(([key, value]) => [Number(key) as T, value as R]))
}
